// src/services/countriesService.js
import { supabase } from '../config';

const CountriesService = {
  /**
   * Get all countries that are included in dropdowns
   * Used by AddressForm and CapRaise components
   */
  async getCountriesForDropdowns() {
    try {
      const { data, error } = await supabase
        .from('countries')
        .select('name, code')
        .eq('included_in_dropdowns', true)
        .order('name', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching countries for dropdowns:', error);
      // Fallback to hardcoded list if database fails
      return [
        { name: 'Australia', code: 'AU' },
        { name: 'United States', code: 'US' },
        { name: 'Canada', code: 'CA' }
      ];
    }
  },

  /**
   * Get all countries (for admin use)
   */
  async getAllCountries() {
    try {
      const { data, error } = await supabase
        .from('countries')
        .select('*')
        .order('name', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching all countries:', error);
      return [];
    }
  },

  /**
   * Get country names as a simple array (for CapRaise compatibility)
   * Returns only countries with included_in_dropdowns = true
   */
  async getCountryNames() {
    try {
      const countries = await this.getCountriesForDropdowns();
      return countries.map(c => c.name);
    } catch (error) {
      console.error('Error fetching country names:', error);
      return ['Australia', 'United States', 'Canada'];
    }
  },

  /**
   * Get ALL country names (for jurisdiction selection - no filtering)
   * Used by CapRaise for offer jurisdiction where all countries should be available
   */
  async getAllCountryNames() {
    try {
      const { data, error } = await supabase
        .from('countries')
        .select('name')
        .order('name', { ascending: true });

      if (error) throw error;
      return data.map(c => c.name);
    } catch (error) {
      console.error('Error fetching all country names:', error);
      // Fallback to hardcoded list
      return ['Australia', 'United States', 'Canada', 'United Kingdom', 'New Zealand', 'Singapore'];
    }
  },

  /**
   * Get country data with states (for AddressForm compatibility)
   * Returns object like: { "Australia": ["New South Wales", ...] }
   */
  async getCountryDataWithStates() {
    try {
      const countries = await this.getCountriesForDropdowns();
      // For now, return countries without states
      // States can be added later if needed
      const countryData = {};
      countries.forEach(country => {
        countryData[country.name] = [];
      });
      return countryData;
    } catch (error) {
      console.error('Error fetching country data with states:', error);
      return {
        "Australia": [],
        "United States": [],
        "Canada": []
      };
    }
  }
};

export default CountriesService;

